import { MessageContentProps } from './Types'
import { TextMessageRenderer } from './TextMessageRenderer'
import { ProcessingContent } from './ProcessingContent'
import { DesignContent } from './DesignPreview/DesignContent'
import { CaptionsContent } from './CaptionsContent/CaptionsContent'
import { UnsupportedRequestContent } from './UnsupportedRequestContent/UnsupportedRequestContent'

export const MessageContent = ({ content, message }: MessageContentProps) => {
  if (content.type === 'text') {
    return <TextMessageRenderer>{content.text + ''}</TextMessageRenderer>
  } else if (content.type === 'processing') {
    return <ProcessingContent content={content} message={message} />
  } else if (content.type === 'design_content') {
    return (
      <DesignContent
        content={content.content}
        width={content.width}
        height={content.height}
        design_id={content.design_id}
      />
    )
  } else if (content.type === 'captions') {
    return <CaptionsContent content={content} />
  } else if (content.type === 'unsupported_request') {
    return <UnsupportedRequestContent content={content} />
  }

  return null
}
